module.exports = __webpack_public_path__ + "static/bedroom_top_left_night-09ebaf0246e502de23faf33d1cd8ac53.jpg";